import './_input.scss';
import './_input.twig';
import { NumberParser } from '../../00-protons/services/number-parser';
import { formatDecimal } from '../../00-protons/services/number-format';

export const name = 'input';

export function disable() {}

const numberParser = new NumberParser();

/**
 *
 * @param {HTMLElement|HTMLDocument} context
 */
export function enable(context) {
  context.querySelectorAll('input[type="number"][data-intl-format]').forEach(
    /**
     * @param {HTMLInputElement} numberInput
     */
    (numberInput) => {
      if (numberInput.dataset.faked) {
        return;
      }
      const step = parseFloat(numberInput.step);
      let fractionDigits = 0;
      if (step && 0 < step && step < 1) {
        fractionDigits = Math.ceil(-Math.log10(step));
      }

      const fakeInput = document.createElement('input');
      fakeInput.type = 'text';
      fakeInput.value = numberInput.value ? formatDecimal(parseFloat(numberInput.value), fractionDigits) : '';

      numberInput.hidden = true;
      numberInput.insertAdjacentElement('afterend', fakeInput);

      fakeInput.addEventListener('change', (e) => {
        fakeInput.value = formatDecimal(
          numberParser.parse(e.target.value),
          fractionDigits
        );
        numberInput.value = numberParser.parse(fakeInput.value).toString();
      });
      numberInput.dataset.faked = 'true';
    }
  );
}

export default enable;
